const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/welcome/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/welcome/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
import { normalizeWelcomeSearch } from "./-welcome-route";
export const Route = createFileRoute("/_app/welcome/")({
  validateSearch: normalizeWelcomeSearch,
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "postOnboarding"
    });
    return {
      meta: buildPrivatePageMetaTags(t("metadataTitle"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});